import * as React from 'react';
import { useTagPickerInput_unstable } from './useTagPickerInput';
import { renderTagPickerInput_unstable } from './renderTagPickerInput';
import { useTagPickerInputStyles_unstable } from './useTagPickerInputStyles.styles';
import { useCustomStyleHook_unstable } from '@fluentui/react-shared-contexts';
/**
 * TagPickerInput component -
 * A TagPickerInput is a composite component that allows users to query tags.
 */ export const TagPickerInput = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useTagPickerInput_unstable(props, ref);
    useTagPickerInputStyles_unstable(state);
    useCustomStyleHook_unstable('useTagPickerInputStyles_unstable')(state);
    return renderTagPickerInput_unstable(state);
});
TagPickerInput.displayName = 'TagPickerInput';
